/* Slider ảnh + chấm màu cho thẻ sản phẩm ở trang collection.
   Chỉ nạp ở sections/main-collection.liquid.

   Toàn bộ là event delegation trên document, KHÔNG init theo từng thẻ: lưới sản phẩm bị
   dựng lại khi lọc/sắp xếp/phân trang (component-collection-filter-bar.js thay innerHTML), nên thẻ
   mới phải hoạt động ngay mà không cần chạy lại hàm khởi tạo nào. Sự kiện scroll không nổi
   bọt nên bắt ở pha capture. */
(function () {
  'use strict';

  function activeTrack(card) {
    var set = card.querySelector('.knt-card__set:not([hidden])');
    return set ? set.querySelector('[data-knt-track]') : null;
  }

  function syncDots(track) {
    // Chấm nằm trong từng set, không phải trong card — mỗi màu có số ảnh riêng.
    var set = track.closest('.knt-card__set');
    if (!set) return;
    var dots = set.querySelectorAll('[data-knt-dots] .knt-card__dot');
    if (!dots.length) return;
    var width = track.clientWidth;
    if (!width) return;
    var index = Math.round(track.scrollLeft / width);
    for (var i = 0; i < dots.length; i++) {
      dots[i].classList.toggle('is-active', i === index);
    }
  }

  function selectFamily(card, family) {
    var sets = card.querySelectorAll('.knt-card__set');
    for (var i = 0; i < sets.length; i++) {
      var match = sets[i].getAttribute('data-knt-set') === family;
      sets[i].hidden = !match;
      sets[i].classList.toggle('is-active', match);
      if (match) {
        // Về lại ảnh đầu, không cần hiệu ứng trượt vì set vừa mới hiện ra.
        var track = sets[i].querySelector('[data-knt-track]');
        if (track) {
          var behavior = track.style.scrollBehavior;
          track.style.scrollBehavior = 'auto';
          track.scrollLeft = 0;
          track.style.scrollBehavior = behavior;
          syncDots(track);
        }
      }
    }

    var item = card.closest('.product-loop__item') || card.parentNode;
    var swatches = item ? item.querySelectorAll('[data-knt-swatch]') : [];
    for (var j = 0; j < swatches.length; j++) {
      var on = swatches[j].getAttribute('data-knt-swatch') === family;
      swatches[j].classList.toggle('is-active', on);
      swatches[j].setAttribute('aria-pressed', on ? 'true' : 'false');
    }
  }

  function cardOf(swatch) {
    var item = swatch.closest('.product-loop__item');
    return item ? item.querySelector('[data-knt-card]') : null;
  }

  document.addEventListener('click', function (event) {
    var nav = event.target.closest ? event.target.closest('[data-knt-nav]') : null;
    if (nav) {
      event.preventDefault();
      var card = nav.closest('[data-knt-card]');
      var track = card && activeTrack(card);
      if (!track) return;
      var step = track.clientWidth;
      var dir = parseInt(nav.getAttribute('data-knt-nav'), 10) || 1;
      var next = track.scrollLeft + dir * step;
      // Quay vòng: quá ảnh cuối thì về ảnh đầu và ngược lại.
      var max = track.scrollWidth - step;
      if (next > max + 1) next = 0;
      if (next < -1) next = max;
      track.scrollTo({ left: next, behavior: 'smooth' });
      return;
    }

    var swatch = event.target.closest ? event.target.closest('[data-knt-swatch]') : null;
    if (swatch) {
      event.preventDefault();
      var swatchCard = cardOf(swatch);
      if (swatchCard) selectFamily(swatchCard, swatch.getAttribute('data-knt-swatch'));
    }
  });

  // Chấm màu là <div role="button"> chứ không phải <button> (xem ghi chú trong
  // snippets/product-loop-card-swatches.liquid) nên phải tự bắt phím Enter/Space.
  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Enter' && event.key !== ' ' && event.key !== 'Spacebar') return;
    var swatch = event.target.closest ? event.target.closest('[data-knt-swatch]') : null;
    if (!swatch) return;
    event.preventDefault();
    var card = cardOf(swatch);
    if (card) selectFamily(card, swatch.getAttribute('data-knt-swatch'));
  });

  document.addEventListener(
    'scroll',
    function (event) {
      var track = event.target;
      if (!track || !track.matches || !track.matches('[data-knt-track]')) return;
      syncDots(track);
    },
    true
  );
})();
